<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-3">
                <h4>{{ 'general' | t }}</h4>
              </div>
              <div class="col-sm-8">
                <webshipper-input-string v-model="template_type.name" :label="'name'"></webshipper-input-string>
                <webshipper-input-string v-model="template_type.hook" :label="'hook'"></webshipper-input-string>
                <webshipper-input-string v-model="template_type.models" :label="'models'"></webshipper-input-string>
                <webshipper-input-string
                  v-model="template_type.description"
                  :label="'description'"
                ></webshipper-input-string>
                <file-upload-collapsed v-model="template_type.thumbnail" type="image"></file-upload-collapsed>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ts-check

export default {
  props: {
    template_type: {
      type: Object,
      required: true
    }
  }
};
</script>
